import styled from 'styled-components';

import * as LayoutUtils from './utils';
import type { LayoutPanels, HeaderSpacerContainer } from './utils';
import { txt } from '../../../../locales/i18n';

export const headerSpacerLayoutPanels: LayoutPanels = {
	layoutName: txt('cms.layoutNames.header spacer'),
	panels: [
		{
			label: txt('cms.panelNames.layout container'),
			formKey: 'container',
			type: 'headerSpacerPanel',
		},
	],
};

type HeaderSpacerLayoutProps = {
	container: HeaderSpacerContainer;
};

export const headerSpacerLayoutValues: HeaderSpacerLayoutProps = {
	container: LayoutUtils.defaultHeaderSpacerContainer,
};

export const HeaderSpacerLayout = (props: HeaderSpacerLayoutProps) => (
	<HeaderSpacerPreviewStyled
		styledProps={props}
		{...LayoutUtils.getAnimationProps(props.container.animation)}
	/>
);

const HeaderSpacerPreviewStyled = styled.div<{ styledProps: HeaderSpacerLayoutProps }>`
	height: 4rem;
	background-color: ${({ styledProps }) => styledProps.container.backgroundColor};
`;
